import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updateLTAType } from "common/services/ltas.service";
import Form from "./Form";
import { toast } from "react-toastify";

const UpdateLTAType: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;
  selectedRecord: any;
}> = ({ toggle, isModalOpen, fetchData, selectedRecord }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: selectedRecord?.name,
      description: selectedRecord?.description,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name"),
      description: Yup.string().nullable(),
    }),
    onSubmit: async (values: any) => {
      const data = {
        id: selectedRecord?.id,
        data: {
          name: values["name"],
          description: values["description"] || null,
        },
      };

      setLoading(true);
      try {
        await updateLTAType(selectedRecord?.id, data);
        fetchData();
        validation.resetForm();
        toggle();
        toast.success("LTA type updated successfully", {});
      } catch (e: any) {
        toast.error("LTA type update failed", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      size="lg"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Update LTA Type
      </ModalHeader>

      <Form
        validation={validation}
        isUpdate
        loading={loading}
        toggle={toggle}
      />
    </Modal>
  );
};

export default UpdateLTAType;
